export default __webpack_public_path__ + "static/media/c-emerald-escapade.2ab7db33.png";